import { memo } from 'react';
import SectionTitle from '../../../../../components/sharedcomponents/SectionTitle';
import BarRow from '../../../../../components/sharedcomponents/BarRow';
import AnimatedCounter from '../../../../../components/sharedcomponents/Animations/AnimatedCounter';

interface CityEntry {
  city: string;
  users: string;
}

interface CitiesTabProps {
  data: CityEntry[];
}

const CitiesTab = memo(({ data }: CitiesTabProps) => {
  const cities = data.slice(0, 10);
  const maxUsers = cities.length ? parseInt(cities[0]?.users) || 1 : 1;

  return (
    <div>
      <SectionTitle>Utilisateurs par Ville</SectionTitle>
      <div className="bg-white rounded-2xl border border-blue-100 shadow-sm p-5">
        {cities.map((c, i) => (
          <BarRow
            key={i}
            label={c.city}
            percentage={(parseInt(c?.users || '0') / maxUsers) * 100}
            value={
              <AnimatedCounter
                end={parseInt(c?.users || '0')}
                duration={1000 + i * 200}
              />
            }
          />
        ))}
      </div>
    </div>
  );
});

CitiesTab.displayName = 'CitiesTab';

export default CitiesTab;